import {
  Status,
  usePasswordExpirationStatus,
} from '../../hooks/use-password-expiration-status';
import { PasswordExpirationComingSoonModal } from './components/password-expiration-coming-soon-modal';
import { PasswordExpirationExpiredModal } from './components/password-expiration-expired-modal';

function PasswordExpirationOverlay(): JSX.Element | null {
  const { status, isOpen, setIsOpen } = usePasswordExpirationStatus();

  if (status === Status.EXPIRED) {
    return <PasswordExpirationExpiredModal />;
  }

  if (status === Status.EXPIRES_SOON) {
    return (
      <PasswordExpirationComingSoonModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    );
  }

  return null;
}

export { PasswordExpirationOverlay };
